<template>
  <div>
    <button type="button" class="nav-mobile-open" @click.prevent="openNavMobile" v-show="!isNavMobile"><span class="d-sr-only">모바일 메뉴 보기</span></button>
    <div ref="navMobile" class="nav-mobile" :class="{ 'nav-mobile-on': isNavMobile }">
      <div class="nav-mobile-inner">
        <a href="/" class="nav-mobile-logo">
          <h1>
            <span class="d-sr-only">FINBRIDGE</span>
          </h1>
        </a>
        <v-spacer />
        <button type="button" class="nav-mobile-close" @click.prevent="closeNavMobile"><span class="d-sr-only">모바일 메뉴 닫기</span></button>
      </div>
      <div class="nav-mobile-list">
        <ul ref="navMobile">
          <li v-for="(menu, index) in menus" :key="index">
            <div class="nav-mobile-depth1" v-if="!menu.depth2">
              <router-link :to="{ name: menu.pathName }" v-html="menu.title" />
            </div>
            <div class="nav-mobile-depth2" v-if="menu.depth2">
              <p :data-menu-index="index" v-html="menu.title" />
              <div>
                <div v-for="(menu, index) in menu.depth2" :key="index">
                  <router-link :to="{ name: menu.pathName }" v-html="menu.title" />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="nav-mobile-footer">
        <a href="mailto:help@finbridge.co.kr">고객문의</a>
        <span class="px-3">|</span>
        <a href="mailto:junjung@finbridge.co.kr">제휴문의</a>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import menus from "@/assets/js/menus.json";

export default {
  mixins: [],
  name: "NavMobile",
  components: {},
  props: {},
  data() {
    return {
      isNavMobile: false,
      menus: menus,
      beforeMenuIndex: 0,
      currentMenuIndex: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    openNavMobile() {
      const { navMobile } = this.$refs;

      this.isNavMobile = true;

      gsap.to(navMobile, 0.35, {
        ease: "Power2.easeInOut",
        right: 0
      });
    },
    closeNavMobile() {
      const { navMobile } = this.$refs;

      gsap.to(navMobile, 0.35, {
        ease: "Power2.easeInOut",
        right: "-100%",
        onComplete: () => {
          this.isNavMobile = false;
        }
      });
    },
  },
  created() {
    this.currentMenuIndex = this.$route.meta.menuIndex;
  },
  mouted() {}
};
</script>

<style lang="scss" scoped>
.nav-mobile-open {
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 18px;
  background: url("~@/assets/new/icon/menu_w.svg") no-repeat 0 0;
  background-size: contain;
}
.nav-mobile {
  position: fixed;
  top: 0;
  right: -100%;
  bottom: 0;
  width: 100%;
  background-color: $primary-color;
  &-inner {
    width: 100%;
    height: 52px;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  &-logo {
    display: block;
    width: 107px;
    height: 20px;
    background: url("~@/assets/new/logo-white.svg") no-repeat 0 0;
    background-size: contain;
  }
  &-close {
    display: block;
    width: 24px;
    height: 24px;
    background: url("~@/assets/new/icon/close.svg") no-repeat 0 0;
    background-size: contain;
  }
  &-list {
    display: block;
    overflow-y: auto;
    height: calc(100% - 100px);
    padding: 30px 30px 0;
    ul {
      li {
        list-style: none;
        border-bottom: 1px solid rgba(247, 249, 250, 0.3);
        padding: 12px 0;
        &:last-child {
          border: 0;
        }
        a {
          display: block;
          color: white;
          letter-spacing: -1px;
          text-decoration: none;
          padding: 8px 0;
          opacity: 0.9;
          &.active {
            text-decoration: underline;
            text-underline-position: under;
            opacity: 1;
          }
        }
      }
    }
  }
  &-depth1 {
    font-size: 18px;
    font-weight: 600;
    color: white;
  }
  &-depth2 {
    display: flex;
    justify-content: space-between;
    p {
      font-size: 18px;
      font-weight: 600;
      color: white;
      padding: 8px 0;
      opacity: 0.6;
    }
    a {
      width: 164px;
      font-size: 16px;
    }
  }
  &-footer {
    padding-left: 30px;
    color: white;
    opacity: 0.8;
    a {
      font-size: 13px;
      color: white;
      text-underline-position: under;
    }
    span {
      font-size: 13px;
      font-weight: 100;
    }
  }
  &-on {
    display: block;
    z-index: 201;
  }
}
.header-white .nav-mobile-open {
  background-image: url("~@/assets/new/icon/menu.svg");
}

@include respond-to("small") {
  .nav-mobile-open {
    display: none;
  }
  .nav-mobile {
    display: none;
  }
}
</style>